import React from "react";

const MealDetailShimmer = () => {
  return (
    <section className="relative max-w-7xl mx-auto px-4 py-6 max-h-screen">
      {/* Header */}
      <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
        <div className="h-8 w-8 rounded-full shimmer"></div>
        <div className="h-5 w-40 rounded shimmer mx-auto"></div>
      </div>

      <div className="w-full max-w-7xl bg-transparent md:bg-white rounded-none md:rounded-2xl p-2 md:p-6 space-y-8">
        {/* PHOTOS */}
        <div>
          <div className="h-4 w-36 shimmer rounded mb-4"></div>

          <div className="flex flex-wrap gap-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <div
                key={i}
                className="h-16 w-16 md:h-24 md:w-24 rounded-lg shimmer"
              ></div>
            ))}
          </div>
        </div>

        {/* TITLE + DAYS */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {/* TITLE + PRICE */}
          <div className="space-y-3">
            <div className="h-5 w-40 shimmer rounded"></div>
            <div className="h-5 w-24 shimmer rounded"></div>
            <div className="h-3 w-full shimmer rounded"></div>
            <div className="h-3 w-5/6 shimmer rounded"></div>
          </div>

          {/* DAYS */}
          <div>
            <div className="h-4 w-36 shimmer rounded mb-3"></div>

            <div className="flex gap-2 mb-4">
              {Array.from({ length: 7 }).map((_, i) => (
                <div
                  key={i}
                  className="h-6 w-6 md:h-8 md:w-8 rounded-md shimmer"
                ></div>
              ))}
            </div>

            <div className="flex gap-6">
              <div className="flex items-center gap-2">
                <div className="h-3 w-3 rounded-full shimmer"></div>
                <div className="h-3 w-10 shimmer rounded"></div>
              </div>

              <div className="flex items-center gap-2">
                <div className="h-3 w-3 rounded-full shimmer"></div>
                <div className="h-3 w-12 shimmer rounded"></div>
              </div>
            </div>
          </div>
        </div>

        {/* PRICING */}
        <div>
          <div className="h-4 w-40 shimmer rounded mb-4"></div>

          <div className="grid md:grid-cols-2 gap-4">
            {/* Trial */}
            <div className="border rounded-xl p-4 space-y-3">
              <div className="h-3 w-16 shimmer rounded"></div>
              <div className="h-8 w-full shimmer rounded-lg"></div>
            </div>

            {/* Weekly */}
            <div className="border rounded-xl p-4 space-y-3">
              <div className="h-3 w-20 shimmer rounded"></div>

              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="h-8 w-full shimmer rounded-lg"></div>
              ))}
            </div>

            {/* Monthly */}
            <div className="border rounded-xl p-4 space-y-3 md:col-span-2">
              <div className="h-3 w-24 shimmer rounded"></div>

              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="h-8 w-full shimmer rounded-lg"></div>
              ))}
            </div>
          </div>
        </div>

        {/* CUTOFF */}
        <div>
          <div className="h-4 w-32 shimmer rounded mb-4"></div>

          <div className="flex gap-6">
            <div className="space-y-2">
              <div className="h-3 w-12 shimmer rounded"></div>
              <div className="h-8 w-20 shimmer rounded-lg"></div>
            </div>

            <div className="space-y-2">
              <div className="h-3 w-12 shimmer rounded"></div>
              <div className="h-8 w-20 shimmer rounded-lg"></div>
            </div>
          </div>
        </div>

        {/* EXTRA ITEMS */}
        <div>
          <div className="h-4 w-28 shimmer rounded mb-3"></div>

          <div className="flex flex-wrap gap-2">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="h-8 w-28 rounded-full shimmer"></div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MealDetailShimmer;
